import { useMutation, useQueryClient } from 'react-query'
import { useSnackbar } from 'notistack'
import { updateBanner, UpdateBannerArgs } from 'services/cm-api/update-banner'
import { BannerT, WebApi2Response } from 'types/global'

/**
 * Wraps `PUT /banner/:id`. The merge logic lives on the server —
 * we pass only changed fields and let CMAPI re-validate the
 * resulting row. Error handling mirrors useCreateBanner.
 */
export function useUpdateBanner() {
  const queryClient = useQueryClient()
  const { enqueueSnackbar } = useSnackbar()

  return useMutation((args: UpdateBannerArgs) => updateBanner(args), {
    onSuccess: async (response: WebApi2Response<BannerT>) => {
      if (response.success) {
        enqueueSnackbar('Banner updated', { variant: 'success' })
        await queryClient.invalidateQueries(['getBanners'])
      }
    },
    onError: (err: unknown) => {
      const axiosErr = err as {
        response?: { data?: { error?: { message?: string } } }
      }
      const apiMessage = axiosErr?.response?.data?.error?.message
      enqueueSnackbar(apiMessage ?? 'Failed to update banner', {
        variant: 'error',
      })
      console.error('updateBanner failed: ', err)
    },
  })
}
